(function () {
    'use strict';

    angular
        .module('searchControllers')
        .controller('SearchController', Controller);

    Controller.$inject = ['topBarService'];

    function Controller(topBarService) {
        topBarService.setModule(undefined);
        topBarService.setTitleAndIcon('Search', 'fa fa-search');
    }
})();